import { isObject } from "./guards";

function uToString(value) {
  return value !== null && value !== undefined ? String(value) : "";
}

function uToNumber(value) {
  return Number(value);
}

function uToBoolean(value) {
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }
  return Boolean(value);
}

function uToArray(value) {
  return Array.isArray(value) ? value : [];
}

function uToObject(value) {
  return isObject(value) ? value : {};
}

export { uToArray, uToBoolean, uToNumber, uToObject, uToString };
